import classNames from "classnames/bind";
import CurrencyInputElement from "react-currency-input";

import styles from "../../styles/input.module.scss";

export const CurrencyInput = ({
  design = "one",
  placeholder = " ",
  onChange,
  onBlur,
  onFocus,
  autoFocus,
  label,
  value,
  floatLabel,
  className = "",
  invalid,
  suffix,
  defaultValue,
  onKeyUp,
  disabled,
  precision = 2,
  prefix = "R$ ",
  decimalSeparator = ",",
  thousandSeparator = ".",
  valid = true,
  max,
  name,
  ...props
}) => {
  const cx = classNames.bind(styles);

  const id = props.id || name;

  return (
    <div className={`${styles.inputContainer} ${className}`}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
      <div className={styles.input}>
        <CurrencyInputElement
          id={id}
          type={"tel"}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
          precision={precision}
          prefix={prefix}
          name={name}
          value={value}
          placeholder={placeholder}
          onChangeEvent={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          autoComplete="off"
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          onKeyUp={onKeyUp}
          disabled={disabled}
          className={cx({
            invalid: invalid,
            suffix: suffix,
            [`design-${design}`]: true,
          })}
        />

        {floatLabel && (
          <label
            className={cx({
              float: true,
              invalid: invalid,
            })}
          >
            {floatLabel}
          </label>
        )}
        {suffix && <span className={styles.suffix}>{suffix}</span>}
      </div>

      {invalid && <span className={styles.error} />}
    </div>
  );
};
